import axios from "axios";
import UseEvent from "../hooks/useEvent";

const request = axios.create({
  baseURL: "/",
  withCredentials: true,
});
const loaders = UseEvent();

class http {
  static get({ url, loader = null }) {
    return new Promise((resolve) => {
      if (loader) this.setLoader(loader, true);
      request
        .get(url)
        .then((response) => {
          resolve({
            status: response?.data?.status === 1,
            data: response.data,
          });
          if (response?.data?.status === 3) {
            console.log("authentication");
          }
          if (response?.data?.code === "sms") {
            this.otp();
          }
        })
        .catch((reason) => {
          resolve({ status: false, data: reason.response.data });
        })
        .finally((_) => {
          if (loader) this.setLoader(loader, false);
        });
    });
  }

  static post({ url, data, headers = null, loader = null }) {
    return new Promise((resolve) => {
      if (loader) this.setLoader(loader, true);
      request
        .post(url, data, { headers: headers })
        .then((response) => {
          resolve({
            status: response?.data?.status === 1,
            data: response.data,
          });
          if (response?.data?.status === 3) {
            console.log("authentication");
          }

          if (response?.data?.code === "sms") {
            this.otp();
          }
        })
        .catch((reason) => {
          resolve({ status: false, data: reason.response.data });
        })
        .finally((_) => {
          if (loader) this.setLoader(loader, false);
        });
    });
  }

  static setLoader(loader, status) {
    if (typeof loader === "string") {
      loaders.emit(loader, status);
    } else {
      try {
        loader(status);
      } catch (e) {
        console.info(e.message);
      }
    }
  }

  static otp = () => {
    if ("OTPCredential" in window) {
      const otpCode = document.getElementById("otp-input");
      console.log(otpCode);
      if (otpCode) {
        const ac = new AbortController();
        console.log(ac);
        navigator.credentials
          .get({
            otp: { transport: ["sms"] },
            signal: ac.signal,
          })
          .then((otp) => {
            console.log(otp);
            const input = document.activeElement;
            if (
              input &&
              input.hasAttribute("autocomplete") &&
              input.getAttribute("autocomplete") === "one-time-code"
            ) {
              const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
                window.HTMLInputElement.prototype,
                "value"
              ).set;
              nativeInputValueSetter.call(input, otp.code);
              const ev = new Event("input", { bubbles: true });
              input.dispatchEvent(ev);
              const form = input.closest("form");
              setTimeout(() => {
                input.blur();
                form.dispatchEvent(
                  new Event("submit", { cancelable: true, bubbles: true })
                );
              }, 100);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  };
}

export default http;
